<template>
  <div id="app">
    <v-app>
      <v-container
        v-if="filterCount > 0 && filtersLoaded"
        fluid
      >
        <FilterInput
          v-if="showCampusFilter === 'true'"
          v-model="campusFilter"
          :filter-count="filterCount"
          :filter-name="campuses.Name"
          filter-key="campus-multiselect"
          :filter-options="campuses.Options"
          :field-type="campuses.FieldType"
        />
        <FilterInput
          v-if="showDayFilter === 'true'"
          v-model="dayFilter"
          :filter-count="filterCount"
          :filter-name="dayOptions.Name"
          filter-key="day-multiselect"
          :filter-options="dayOptions.Options"
          :field-type="campuses.FieldType"
        />
        <FilterInput
          v-for="(filter, index) in multiSelectFilters"
          :key="filter.Key"
          v-model="filterValues[index]"
          :filter-count="filterCount"
          :filter-name="filter.Name"
          :filter-options="filter.Options"
          :filter-key="filter.Key"
          :field-type="filter.FieldType"
        />
        <FilterInput
          v-for="(filter, index) in textFields"
          :key="filter.Key"
          v-model="filterValues[index]"
          :filter-count="filterCount"
          :filter-name="filter.Name"
          :filter-options="filter.Options"
          :filter-key="filter.Key"
          :field-type="filter.FieldType"
        />
        <FilterInput
          v-if="showNameandDescriptionFilter === 'true'"
          v-model="textFilter"
          :filter-count="filterCount"
          filter-name="Search Names and Descriptions"
          filter-key="app-text"
          field-type="Text"
        />
      </v-container>
      <v-container
        fluid
      >
        <h4
          v-if="groups && groups.length > 0"
        >
          {{ filteredGroups.length }} / {{ groups.length }} {{ Pluralize('Group', groups.length) }}
          Found
        </h4>
        <div
          is="transition-group"
          v-if="filteredGroups && filteredGroups.length > 0"
          id="gridView"
          ref="gridView"
          name="fade-list"
          :style="{
            '--widthSize': gridWidth,
          }"
        >
          <GroupItem
            v-for="group in filteredGroups"
            :key="group.Guid"
            :group="group"
            :display-attribute-ids="displayAttributeIds"
            :color="colorCalculator(group)"
            :primary-attribute-id="primaryAttributeId"
            :sign-up-page="signUpPage"
            :title-color-is-group-color="titleColorIsGroupColor"
            :show-time="showTime"
            :show-frequency="showFrequency"
            :color-area-attribute-ids="colorAreaAttributeIds"
            :show-primary-attribute-first="showPrimaryAttributeFirst"
            :show-leaders="showLeaders"
            :tag-attribute-ids="tagAtttributeIds"
            :description-attribute-ids="descriptionAttributeIds"
            :group-role-ids="roleIdsToShow"
            :show-map="showMap"
            :api-key="googleApiKey"
          />
        </div>
      </v-container>
    </v-app>
  </div>
</template>

<script>
import Pluralize from 'pluralize';
import FilterInput from './components/filter.vue';
import GroupItem from './components/groupItem.vue';

const baseurl = 'https://{{ "Global" | Page:"Host" }}/';

export default {
  name: 'App',
  components: {
    FilterInput, GroupItem,
  },
  data: () => ({
    groups: null,
    filterAttributeIds: '{{ filterAttributeIds }}',
    displayAttributeIds: '{{ displayAttributeIds }}',
    colorAreaAttributeIds: '{{ colorAreaAttributeIds }}',
    primaryAttributeId: '{{ primaryAttributeId }}',
    tagAtttributeIds: '{{ tagAtttributeIds }}',
    descriptionAttributeIds: '{{ descriptionAttributeIds }}',
    parentGroupIds: '{{ parentGroupIds }}',
    colorList: '{{ colorList }}',
    signUpPage: '{{ signUpPage }}',
    groupType: '{{ groupType }}',
    campusIds: '{{ campusIds }}',
    showCampusFilter: '{{ showCampusFilter }}',
    showDayFilter: '{{ showDayFilter }}',
    showNameandDescriptionFilter: '{{ showNameandDescriptionFilter }}',
    gridHeight: '{{ gridHeight }}',
    gridWidth: '{{ gridWidth }}',
    titleColorIsGroupColor: '{{ titleColorIsGroupColor }}',
    showTime: '{{ showTime }}',
    showFrequency: '{{ showFrequency }}',
    showPrimaryAttributeFirst: '{{ showPrimaryAttributeFirst }}',
    showLeaders: '{{ showLeaders }}',
    roleIdsToShow: '{{ roleIdsToShow }}',
    showMap: '{{ showMap }}',
    googleApiKey: '{{"Global" | Attribute:"GoogleAPIKey" }}',
    campuses: null,
    filtersLoaded: false,
    includePendingMembersInGroupCapacity: '{{ includePendingMembersInGroupCapacity | Default:"False" }}',
    dayOptions: {
      FieldType: 'Multi-select',
      Key: 'Days',
      Name: 'Meeting Days',
      Options:
          [
            {
              Text: 'Sunday',
              Value: 'Sun',
            },
            {
              Text: 'Monday',
              Value: 'Mon',
            },
            {
              Text: 'Tuesday',
              Value: 'Tue',
            },
            {
              Text: 'Wednesday',
              Value: 'Wed',
            },
            {
              Text: 'Thursday',
              Value: 'Thu',
            },
            {
              Text: 'Friday',
              Value: 'Fri',
            },
            {
              Text: 'Saturday',
              Value: 'Sat',
            },
          ],
    },
    filters: [],
    filterValues: [],
    textFilter: '',
    campusFilter: null,
    dayFilter: null,
  }),
  computed: {
    // buildQueryParams() {
    //   const params = [];
    //   if (this.textFilter && this.textFilter.Value.length > 0) params.push(`${this.textFilter.Key}=${this.textFilter.Value}^${encodeURIComponent(this.textFilter.Type)}`);

    //   if (this.campusFilter && this.campusFilter.Value.length > 0) params.push(`${this.campusFilter.Key}=${this.campusFilter.Value}^${encodeURIComponent(this.campusFilter.Type)}`);

    //   if (this.dayFilter && this.dayFilter.Value.length > 0) params.push(`${this.dayFilter.Key}=${this.dayFilter.Value}^${encodeURIComponent(this.dayFilter.Type)}`);

    //   this.filterValues.forEach((x) => {
    //     if (x.Value.length > 0) params.push(`${x.Key}=${x.Value.toString()}^${encodeURIComponent(x.Type)}`);
    //   });
    //   return params.join('&');
    // },
    filterCount() {
      let filterCount = this.filters.length;
      if (this.showCampusFilter === 'true') filterCount += 1;
      if (this.showDayFilter === 'true') filterCount += 1;
      if (this.showNameandDescriptionFilter === 'true') filterCount += 1;

      return filterCount;
    },
    multiSelectFilters() {
      return this.filters.filter((e) => e.Options.length > 0);
    },
    textFields() {
      return this.filters.filter((e) => !e.Options || e.Options.length === 0);
    },
    filteredGroups() {
      if (!this.groups) return [];
      const filterTemplate = this.filterValues.reduce((acc, filter) => {
        if (typeof filter.Type === 'undefined' || typeof filter.Value === 'undefined' || filter.Value.length === 0) return acc;
        // if (filter.Type === 'Integer Range' || filter.Type === 'Text') return acc;
        const object = {};
        if (typeof filter.Value === 'string') {
          if (filter.Type === 'Integer Range' || filter.Type === 'Text') {
            object.Value = filter.Value;
            object.Type = filter.Type;
            acc[filter.Key] = object;
          } else {
            object.Value = filter.Value.split(',');
            object.Type = filter.Type;
            acc[filter.Key] = object;
          }
        }
        if (Array.isArray(filter.Value)) {
          object.Value = filter.Value;
          object.Type = filter.Type;
          acc[filter.Key] = object;
        }

        return acc;
      }, {});
      function rangeTest(lowValue, highValue, filterValue) {
        // eslint-disable-next-line max-len
        return parseInt(filterValue, 10) >= parseInt(lowValue, 10) && parseInt(filterValue, 10) <= parseInt(highValue, 10);
      }
      function findByTemplate(list, template) {
        return list.filter(
          (item) => Object.keys(template).every(
            (propertyName) => {
              if (template[propertyName].Type !== 'Integer Range' && template[propertyName].Type !== 'Text') {
                return item.AttributeValues[propertyName]
                  .RawValue.toLowerCase().split(',').some((item2) => template[propertyName].Value
                    .includes(item2.toLowerCase()));
              } if (template[propertyName].Type === 'Integer Range') {
                return rangeTest(item.AttributeValues[propertyName].RawValue.split(',')[0], item.AttributeValues[propertyName].RawValue.split(',')[1], template[propertyName].Value);
              // eslint-disable-next-line no-else-return
              } else {
                // eslint-disable-next-line max-len
                return item.AttributeValues[propertyName].RawValue.toLowerCase().indexOf(template[propertyName].Value.toLowerCase()) > -1;
              }
            },
          ),
        );
      }
      let found = this.groups.filter(
        (x) => !x.Capacity || x.Capacity - x.GroupMemberCount > 0,
      );
      found = findByTemplate(found, filterTemplate);
      // Campus Filter
      if (this.campusFilter && this.campusFilter.Value && this.campusFilter.Value.length > 0) {
        const values = [];
        this.campusFilter.Value.map((x) => values.push(parseInt(x, 10)));
        found = found.filter((g) => values.includes(g.CampusId));
      }
      // Day Filter
      if (this.dayFilter && this.dayFilter.Value && this.dayFilter.Value.length > 0) {
        found = found.filter((g) => this.dayFilter.Value.includes(g.DayOfWeek));
      }
      // Text Filter
      if (this.textFilter !== '') {
        found = found.filter((g) => g.Name.toLowerCase().includes(this.textFilter.Value.toLowerCase()) || (g.Description && g.Description.toLowerCase().includes(this.textFilter.Value.toLowerCase()))); // eslint-disable-line max-len
      }
      found = found.sort((a, b) => {
        const nameA = a.Name.toUpperCase(); // ignore upper and lowercase
        const nameB = b.Name.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      });
      return found;
    },
  },
  // watch: {
  //   buildQueryParams: (val) => {
  //     const url = `${window.location.origin}${window.location.pathname}?${val}`;
  //     window.history.replaceState({}, '', url);
  //   },
  // },
  async created() {
    function showLoader() {
      const spinner = document.getElementById('updateProgress');
      if (!spinner) return;
      spinner.style.display = 'block';
    }

    function hideLoader() {
      const spinner = document.getElementById('updateProgress');
      if (!spinner) return;
      spinner.style.display = 'none';
    }

    try {
      showLoader();

      const newArray = [];
      newArray.push(...this.filterAttributeIds.split(','));
      newArray.push(...this.displayAttributeIds.split(','));
      newArray.push(...this.colorAreaAttributeIds.split(','));
      newArray.push(...this.primaryAttributeId.split(','));
      newArray.push(...this.tagAtttributeIds.split(','));
      newArray.push(...this.descriptionAttributeIds.split(','));

      const groupurl = `${baseurl}api/com_bemaservices/GroupTools/GetGroupsInformation?groupTypeIds=${parseInt(this.groupType, 10)}${newArray.length > 0 ? `&requestedAttributeIds=${newArray.join(',')}` : ''}${this.campusIds ? `&campusIds=${this.campusIds}` : ''}${this.parentGroupIds ? `&parentGroupIds=${this.parentGroupIds}` : ''}&IncludePendingMembersInGroupCapacity=${this.includePendingMembersInGroupCapacity}`;
      const getCampusesUrl = `${baseurl}api/Campuses?$filter=IsActive%20eq%20true`;

      if (this.filterAttributeIds && this.filterAttributeIds.length > 0) {
        const response = await fetch(`${baseurl}api/com_bemaservices/GroupTools/GetAttributeInformationList?attributeIds=${this.filterAttributeIds}`);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        this.filters = data;
        this.filtersLoaded = true;
      } else {
        this.filtersLoaded = true;
      }
      const response1 = await fetch(groupurl);
      if (!response1.ok) {
        throw new Error(`HTTP error! status: ${response1.status}`);
      }

      const response2 = await fetch(getCampusesUrl);

      if (!response2.ok) {
        throw new Error(`HTTP error! status: ${response1.status}`);
      }
      const campusesObject = {
        FieldType: 'Multi-select',
        Key: 'Campuses',
        Name: 'Campuses',
        Options: [],
      };

      const campuses = await response2.json();
      campuses.forEach((c) => {
        const option = {};
        option.Text = c.Name;
        option.Value = c.Id;
        campusesObject.Options.push(option);
      });

      this.campuses = campusesObject;

      this.groups = await response1.json();

      hideLoader();
      // const urlSearchParams = new URLSearchParams(window.location.search);
      // const params = Object.fromEntries(urlSearchParams.entries());
      // console.log(params);
      // Object.entries(params).forEach((x) => {
      //   if (x[0] === 'campus-multiselect') {
      //     const filterObject = {};
      //     // eslint-disable-next-line prefer-destructuring
      //     filterObject.Key = x[0];
      //     // eslint-disable-next-line prefer-destructuring
      //     filterObject.Type = x[1].split('^')[1];
      //     filterObject.Value = x[1].split('^')[0].split(',').map(Number);
      //     this.campusFilter = filterObject;
      //   }
      // });
    } catch (e) {
      console.log(e);
      hideLoader();
    }
  },
  methods: {
    colorCalculator(group) {
      const attribute = this.filters.find((x) => x.Id === parseInt(this.primaryAttributeId, 10));
      if (!attribute) return this.colorList.split(',')[0];
      const { RawValue } = group.AttributeValues[attribute.Key];
      const colors = {};
      attribute.Options.forEach((x, index) => {
        colors[x.Value.toLowerCase()] = this.colorList.split(',')[index];
      });
      if (!RawValue) return '';
      return colors[RawValue.toLowerCase()];
    },
    Pluralize(text, qty) {
      return Pluralize(text, qty);
    },
  },
};
</script>

<style lang="less">
:root {
  --widthSize: 400px;
}
.fade-list-move {
  transition: transform 0.25s ease;
}

.fade-list-leave-to {
  transition: all 0.5s ease;
  opacity: 0;
}
#gridView {
  // display:flex;
  // flex-direction:row;
  // justify-content:flex-start;
  // align-items:stretch;
  display:grid;
  grid-template-columns: repeat(auto-fill, minmax(var(--widthSize), 1fr));
  grid-gap:1.5rem;
  grid-auto-flow: row dense;
}
</style>
